import React, { useState } from "react";
import { InterviewSidebarSection } from "../Components/InterviewSidebarSection";
import * as fileDownloader from "../../../../services/fileDownloader";
import fileSvgIcon from "../../../../resources/matt-icons_file-x-generic.svg";
import { AddAdditional } from "@coverme/forms";
import { AddDocumentsModal } from "../../../../components/Documents/AddDocumentsModal";


const DocumentItem = ({
    documentType,
    documentSubType,
    uploadedBy,
    dateCreated,
    documentId,
    canDelete,
    personId,
    onDelete,
    hasDeletePermission,
}) => {
    function downloadFile() {
        fileDownloader.downloadFile(`/api/person/${personId}/document/${documentId}`, {}, false);
    }

    return (
        <div className="row document-row">
            <img src={fileSvgIcon} height="16px" alt={"file-icon"} />
            <a href="javascript:void(0)" onClick={downloadFile}>
                {documentType} - {documentSubType}
            </a>
        </div>
    );
};

export const InterviewSidebarDocumentation = ({ documents, patientId, ...props }) => {
    const patientDocuments = documents.data[patientId] == null ? [] : documents.data[patientId];
    const [isModalShown, setIsModalShown] = useState(false);
    
    return (
        <InterviewSidebarSection title="Documents" {...props}>
            {patientDocuments.map(x => (
                <DocumentItem {...x} personId={patientId} />
            ))}
            {patientDocuments.length === 0 && <p className="no-documents-found">No documents found</p>}
            <AddAdditional clickEvent={() => setIsModalShown(true)} labelText={"Add Document"} />
            <AddDocumentsModal  onClose={() => setIsModalShown(false)} isShown={isModalShown} />


        </InterviewSidebarSection>
    );
};
